
const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-background">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto">
          <div className="bg-red-50 dark:bg-red-950/30 border border-red-100 dark:border-red-900/50 rounded-lg p-6 mb-8">
            <p className="text-red-800 dark:text-red-200 leading-relaxed">
              Chez Skillengers, nous attachons une grande importance à la confidentialité et à la protection des données personnelles de nos utilisateurs. Cette politique de confidentialité vise à vous informer sur la manière dont nous collectons, utilisons, stockons et protégeons vos données personnelles lorsque vous utilisez notre plateforme.
            </p>
          </div>

          <div className="bg-card p-8 rounded-lg shadow-sm border border-border">
            <h1 className="text-3xl font-bold text-brand-blue dark:text-brand-orange mb-8">
              Politique de Confidentialité
            </h1>
            
            <div className="space-y-8 text-muted-foreground">
              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Collecte et utilisation des données personnelles
                </h2>
                <p className="mb-4">
                  Lorsque vous utilisez notre plateforme, nous pouvons collecter les données personnelles suivantes :
                </p>
                <ul className="list-disc pl-6 space-y-2 mb-4">
                  <li>Informations d'identification : nom, prénom, adresse e-mail, etc.</li>
                  <li>Informations professionnelles : CV, expérience professionnelle, compétences, etc.</li>
                  <li>Informations de connexion : adresse IP, informations sur votre navigateur, données de connexion, etc.</li>
                </ul>
                <p>
                  Nous collectons ces données personnelles dans le but de vous offrir des services personnalisés, d'améliorer notre plateforme et de répondre à vos demandes. Nous ne collectons que les données nécessaires à ces fins et nous nous engageons à les utiliser de manière légale, loyale et transparente.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Conservation des données
                </h2>
                <p>
                  Nous conservons vos données personnelles aussi longtemps que nécessaire pour atteindre les objectifs pour lesquels elles ont été collectées, sauf si la loi exige ou autorise une période de conservation plus longue. Nous prenons les mesures appropriées pour nous assurer que vos données sont protégées contre toute utilisation ou accès non autorisé.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Protection des données
                </h2>
                <p>
                  Nous mettons en place des mesures de sécurité techniques et organisationnelles pour protéger vos données personnelles contre toute perte, altération, accès non autorisé ou divulgation. Nous utilisons des protocoles de sécurité avancés et nous nous engageons à respecter les normes de sécurité en vigueur pour garantir la confidentialité de vos données.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Partage des données personnelles
                </h2>
                <p className="mb-4">
                  Nous ne partageons pas vos données personnelles avec des tiers, sauf dans les cas suivants :
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Lorsque cela est nécessaire pour fournir les services que vous avez demandés (par exemple, le partage de votre CV avec des employeurs potentiels).</li>
                  <li>Lorsque cela est requis par la loi, une autorité gouvernementale ou une décision judiciaire.</li>
                  <li>Lorsque cela est nécessaire pour protéger nos droits, notre propriété ou notre sécurité, ainsi que ceux de nos utilisateurs ou du public.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Vos droits
                </h2>
                <p>
                  Vous avez le droit d'accéder à vos données personnelles, de les rectifier, de les supprimer ou de limiter leur traitement. Vous avez également le droit de vous opposer au traitement de vos données personnelles et le droit à la portabilité de vos données. Vous pouvez exercer ces droits en nous contactant à l'adresse mentionnée ci-dessous.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Responsable de la protection des données
                </h2>
                <p>
                  Notre responsable de la protection des données est Pascale MOCQUANT. Vous pouvez la contacter à l'adresse suivante : contact@skillengers.io
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">
                  Modifications de la politique de confidentialité
                </h2>
                <p>
                  Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur notre site web, et nous vous encourageons à consulter régulièrement cette politique pour vous tenir informé des éventuelles mises à jour.
                </p>
              </section>

              <section>
                <p className="mb-4">
                  Nous vous remercions de votre confiance et de votre utilisation de Skillengers. Si vous avez des questions ou des préoccupations concernant notre politique de confidentialité, n'hésitez pas à nous contacter à l'adresse contact@skillengers.io
                </p>
                <p className="text-sm text-muted-foreground">
                  Dernière mise à jour : 01/02/2025
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
